import axios, { AxiosRequestConfig } from 'axios';
import store from '../store';

export const readonlyApi = axios.create({
    baseURL: process.env.REACT_APP_READONLY_API_URL, 
    timeout: 7200000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

readonlyApi.interceptors.request.use((config: AxiosRequestConfig) => {
    const state = store.getState();
    const token = state.user.object?.user?.accessToken; 
    
    if (!config.headers) {
        config.headers = {} as any;
    }

    if (token && config.headers) {
        config.headers['x-access-token'] = token;
    }
    
    return config;
}, (error) => {
    return Promise.reject(error);
});
